export const LEVEL_DEFINITIONS = [
  {
    id: 1,
    name: 'Canopy Trail',
    topic: 'Mixed Basics',
    allowedTopics: ['arithmetic', 'algebra'],
    questionCount: 4,
    difficulty: 'easy',
    encounters: [
      {
        type: 'bridge',
        title: 'Vine Bridge',
        shortLabel: 'Bridge',
        icon: '🌉',
        description: 'Cross the hanging bridge while the canopy sways overhead.',
      },
      {
        type: 'rescue',
        title: 'Monkey Rescue',
        shortLabel: 'Rescue',
        icon: '🐒',
        description: 'Help the scout monkeys regroup before the path disappears.',
      },
      {
        type: 'gate',
        title: 'Temple Gate',
        shortLabel: 'Gate',
        icon: '🛕',
        description: 'Unlock the carved gate that guards the next stretch of jungle.',
      },
    ],
  },
  {
    id: 2,
    name: 'Temple Steps',
    topic: 'Arithmetic',
    allowedTopics: ['arithmetic'],
    questionCount: 5,
    difficulty: 'easy',
    encounters: [
      {
        type: 'stairs',
        title: 'Broken Steps',
        shortLabel: 'Steps',
        icon: '🪜',
        description: 'Count the safe footholds up the cracked staircase.',
      },
      {
        type: 'torch',
        title: 'Torch Gallery',
        shortLabel: 'Gallery',
        icon: '🔥',
        description: 'Light the gallery in the right order to keep moving.',
      },
      {
        type: 'altar',
        title: 'Hidden Altar',
        shortLabel: 'Altar',
        icon: '🗿',
        description: 'Solve the altar puzzle before the stone doors close again.',
      },
    ],
  },
  {
    id: 3,
    name: 'River Riddles',
    topic: 'Algebra',
    allowedTopics: ['algebra'],
    questionCount: 5,
    difficulty: 'medium',
    encounters: [
      {
        type: 'raft',
        title: 'Raft Crossing',
        shortLabel: 'Raft',
        icon: '🛶',
        description: 'Balance the raft and read the current before it pulls you downstream.',
      },
      {
        type: 'bank',
        title: 'Crocodile Bank',
        shortLabel: 'Bank',
        icon: '🐊',
        description: 'Keep the crocodiles at bay while you hold the riverbank.',
      },
      {
        type: 'shrine',
        title: 'River Shrine',
        shortLabel: 'Shrine',
        icon: '⛩️',
        description: 'Unlock the shrine with the final pattern from the river spirits.',
      },
    ],
  },
  {
    id: 4,
    name: 'Stone Garden',
    topic: 'Geometry',
    allowedTopics: ['geometry'],
    questionCount: 6,
    difficulty: 'medium',
    encounters: [
      {
        type: 'maze',
        title: 'Stone Maze',
        shortLabel: 'Maze',
        icon: '🧱',
        description: 'Read the angles in the stone paths to avoid dead ends.',
      },
      {
        type: 'pond',
        title: 'Mirror Pond',
        shortLabel: 'Pond',
        icon: '🪞',
        description: 'Use reflected shapes to reveal the hidden walkway.',
      },
      {
        type: 'keeper',
        title: 'Garden Keeper',
        shortLabel: 'Keeper',
        icon: '🪨',
        description: 'Convince the ancient keeper to open the final gate.',
      },
    ],
  },
  {
    id: 5,
    name: 'Golden Idol',
    topic: 'Mixed Mastery',
    allowedTopics: ['arithmetic', 'algebra', 'geometry'],
    questionCount: 7,
    difficulty: 'hard',
    encounters: [
      {
        type: 'vault',
        title: 'Outer Vault',
        shortLabel: 'Vault',
        icon: '🪙',
        description: 'Unlock the outer chamber without waking the traps.',
      },
      {
        type: 'chamber',
        title: 'Echo Chamber',
        shortLabel: 'Echo',
        icon: '🔔',
        description: 'Match the echoing patterns before the chamber seals.',
      },
      {
        type: 'idol',
        title: 'Idol Sanctum',
        shortLabel: 'Sanctum',
        icon: '✨',
        description: 'Claim the idol by mastering every lesson the jungle taught you.',
      },
    ],
  },
];

export const getLevelDefinition = (levelId) =>
  LEVEL_DEFINITIONS.find((level) => level.id === Number(levelId)) ?? null;
